import * as React from 'react';

const InterviewIcon = () => {
  return (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M28.1562 4H2.96875C2.43594 4 2 4.43594 2 4.96875V23.375H3.9375V5.9375H21.375V21.4375H5.875V23.375H14.5938V25.3125H9.75V27.25H21.375V25.3125H16.5312V23.375H28.1562C28.6891 23.375 29.125 22.9391 29.125 22.4062V4.96875C29.125 4.43594 28.6891 4 28.1562 4ZM23.3125 5.9375H27.1875V9.8125H23.3125V5.9375ZM23.3125 11.75H27.1875V15.625H23.3125V11.75ZM23.3125 21.4375V17.5625H27.1875V21.4375H23.3125Z"
        fill="black"
      />
      <path
        d="M15.5 10.6562C15.5 9.05781 14.1922 7.75 12.5938 7.75C10.9953 7.75 9.6875 9.05781 9.6875 10.6562C9.6875 12.2547 10.9953 13.5625 12.5938 13.5625C14.1922 13.5625 15.5 12.2547 15.5 10.6562ZM11.625 10.6562C11.625 10.1234 12.0609 9.6875 12.5938 9.6875C13.1266 9.6875 13.5625 10.1234 13.5625 10.6562C13.5625 11.1891 13.1266 11.625 12.5938 11.625C12.0609 11.625 11.625 11.1891 11.625 10.6562Z"
        fill="black"
      />
      <path
        d="M7.75 19.375H9.6875C9.6875 17.7766 10.9953 16.4688 12.5938 16.4688C14.1922 16.4688 15.5 17.7766 15.5 19.375H17.4375C17.4375 16.7013 15.2675 14.5312 12.5938 14.5312C9.92 14.5312 7.75 16.7013 7.75 19.375Z"
        fill="black"
      />
    </svg>
  );
};

export default InterviewIcon;
